import React from "react"
import cn from "classnames"
import TextareaAutosize from "react-textarea-autosize"
import { FieldInputProps, FieldMetaProps } from "formik"
import { ClassProps } from "../../utility/common/props"
import { Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import styles from "./FormikTextareaAutosize.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons/faExclamationCircle"

export interface FormikTextareaAutosizeProps extends ClassProps {
    id: string
    field: FieldInputProps<string>
    meta: FieldMetaProps<string>
    placeholder: string
}

const FormikTextareaAutosize: React.FC<FormikTextareaAutosizeProps> = props => {
    const { t } = useTranslation()
    const { className, id, field, meta, placeholder } = props
    const { error } = meta

    return (
        <div>
            <div
                className={cn(
                    styles.validatableTextarea,
                    meta.touched && !!error && styles.validatableTextarea_isInvalid
                )}
            >
                <TextareaAutosize
                    onKeyPress={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
                        if (e.key === "Enter") e.preventDefault()
                    }}
                    id={id}
                    name={field.name}
                    onChange={field.onChange}
                    placeholder={placeholder}
                    className={className}
                    value={field.value}
                    onBlur={field.onBlur}
                />
                {error && (
                    <div className={styles.validatableTextarea__invalidIcon}>
                        <FontAwesomeIcon icon={faExclamationCircle} />
                    </div>
                )}
            </div>
            {error && (
                <Form.Control.Feedback type="invalid" className={styles.invalidFeedback}>
                    {t(error)}
                </Form.Control.Feedback>
            )}
        </div>
    )
}

export default FormikTextareaAutosize
